import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild, ElementRef  } from '@angular/core';
import { Subscription, Observable, combineLatest, Subject } from "rxjs";

import { map, concatMap } from "rxjs/operators";
import { LoaderService } from "../../../common/services/loader.service";
import { WorkOrderService } from "../../../common/services/work-order.service";
import { WorkOrder, WorkOrderType, WorkOrderStatus } from "../../../common/models/work-order.model";
import { FlowOnBehalfService } from "../../../flow/services/flow-on-behalf.service";
import { parseFileNameFromHeaders } from "../../../common/models/onBaseIntegrationAndMapping.model";

import { FlowInstance } from "../../../flow/models/flow.model";
import { OrganizationStub } from "../../../common/models/organization.model";
import { InitializeOnBehalfSpec } from "../../models/on-behalf.model";
import { DocumentManagementService, IAzureBlobSasToken, IUploadFile } from "../../../common/services/document-management.service";
import { RequestForScanning } from "../../../common/models/scan-documents.model";
import { ScanRequestService } from "../../../admin/services/scan-request.service";


@Component({
    selector: 'on-behalf-scanning-document',
    templateUrl: './on-behalf-scanning-document.component.html',
    styleUrls: ['./on-behalf-scanning-document.component.scss'],
    standalone: false
})
export class OnBehalfScanningDocumentComponent implements OnInit, OnDestroy {

    @Input() applicationNumber: string = "";
    @Output() applicationSubmitted: EventEmitter<string> = new EventEmitter<string>();
    @Input() applicationType: string = "";
    @Output() cancelRequest: EventEmitter<any> = new EventEmitter<any>();
    private coversheetBlob: any[] = [];
    @ViewChild("downloadLink", { static: true } ) download: ElementRef;

    @Input() organization: OrganizationStub;

    get organizationNumber(): string {
        let value: string = "";
        if (this.organization) {
            value = this.organization.id;
        }
        return value;
    }


    @Output() throwError: EventEmitter<any> = new EventEmitter<any>();



    subscription: Subscription = new Subscription();
    workOrders: WorkOrder[] = [];

    constructor(private workOrderService: WorkOrderService, private onBehalfService: FlowOnBehalfService, private docService: DocumentManagementService, private scanService: ScanRequestService,
         public loader: LoaderService) { }

    ngOnInit() {
        
    };

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    } 

    cancel(): void {
        this.cancelRequest.emit("cancelled");
    }

    generateCoversheet(request: RequestForScanning): Observable<WorkOrder> {
        return this.docService.generateScanningCover(request).pipe(concatMap((data) => {
            let fileBlob = new Blob([data.body], { type: "application/pdf" });
            let fileName = parseFileNameFromHeaders(data.headers.get("content-disposition"));
            (fileBlob as any).name = fileName;
            (fileBlob as any).lastModifiedDate = new Date();
            this.coversheetBlob.push(fileBlob);
            return this.docService.provision(fileName).pipe(concatMap((token: IAzureBlobSasToken) => {
                request.coversheetUrl = token.blobUri
                request.isPaperApplication = true;
                this.docService.processProvisionedFile({ rawFile: <File>(fileBlob as any), completed: false, isUploading: true, percentage: 0, fileName: fileName, type: "application/pdf", blobUri: token.blobUri } as IUploadFile, token, new Subject<IAzureBlobSasToken>())
                return this.workOrderService.submitScanRequest(request);
            }));
        }));
    }

    renderBlobs(data: any[]): void {
        for (let u = 0; u < data.length; u++) {
            const fileName = data[u].name;
            let url = window.URL.createObjectURL(data[u]);
            const link = this.download.nativeElement;
            link.href = url;
            link.download = fileName;
            link.click();
        }
    }

    rethrowError(event: any): void {
        this.throwError.emit(event);
    }

    requestsCreated(requests: RequestForScanning[]): void {
        let obs$: Observable<WorkOrder>[] = [];
        requests.forEach(r => obs$.push(this.generateCoversheet(r)));  
        this.loader.toggleLoader(true);
        let submitSubs$ = combineLatest(...obs$).pipe(concatMap((orders: WorkOrder[]) => {
            this.workOrders = orders;
            let spec: InitializeOnBehalfSpec = {
                workflowTemplateId: this.applicationType,
                onBehalfOrganizationId: this.organization.id,
                instanceIdentifier: this.applicationNumber
            } as InitializeOnBehalfSpec;
            this.workOrders.forEach(w => {
                w.flowTemplateId = this.applicationType;
                w.type = WorkOrderType.ScanDocuments;
                w.status = WorkOrderStatus.Pending;
                w.organizationId = this.organization.id;
                w.companyName = this.organization.name;
                w.applicationNumber = this.applicationNumber;
            });
            return this.onBehalfService.initializeFlow(spec);
        }),
            concatMap((instance: FlowInstance) => {
                let saveWOObs$: Observable<WorkOrder>[] = [];
                this.workOrders.forEach(w => {
                    w.flowInstanceId = instance.id;
                    saveWOObs$.push(this.workOrderService.save(w));
                });
                return combineLatest(...saveWOObs$);
            })).subscribe((data: WorkOrder[]) => {
                this.renderBlobs(this.coversheetBlob);
                this.loader.toggleLoader(false);
                this.applicationSubmitted.emit(this.applicationNumber);
            },
            (error) => { console.error(error); }
        );
        this.subscription.add(submitSubs$);
    }
}
